import React, { createContext, useState } from 'react';
import intl from 'react-intl-universal';

const PageTitleContext = createContext({});

function PageTitleProvider({ history, children }) {
  const [isAnnouceable, setIsAnnounce] = useState(false);
  const [announceText, setAnnounceText] = useState(null);

  const setPageTitle = title => {
    document.title = `${title} | ${intl.get('default.title')}`;

    if (!isAnnouceable) {
      return setIsAnnounce(true);
    }

    setAnnounceText(`Navigated to ${title} Page`);

    /* set focus to main content */
    const contentElId = document.getElementById('content');
    if (contentElId) {
      contentElId.focus();
    }
  };

  return (
    <PageTitleContext.Provider value={{ setPageTitle }}>
      {isAnnouceable && (
        <span className="aria-pagetitle" aria-live="polite" aria-atomic="true">
          {announceText}
        </span>
      )}
      {children}
    </PageTitleContext.Provider>
  );
}

export { PageTitleContext };
export default PageTitleProvider;
